import { UntypedFormGroup, UntypedFormControl, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Utils } from '../core/utils';


export function emailValidator(control: UntypedFormControl): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        const emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
        var isInvalid = control.value && !emailRegexp.test(control.value);
        return isInvalid ? { invalidEmail: true } : null;
    }
}

export function phoneValidator(control: UntypedFormControl): ValidatorFn  {
    return (control:AbstractControl) : ValidationErrors | null => {
        const emailRegexp = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
        var isInvalid = control.value && !emailRegexp.test(control.value) || false;
        return isInvalid ? { invalidPhone:true }: null;
    }
}

export function noWhitespaceValidator(control: UntypedFormControl): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isInvalid = !isWhitespace;
        return isInvalid ? { 'whitespace': true } : null;
    }
}

export function passwordValidator(control: UntypedFormControl):ValidatorFn  {
    return (control:AbstractControl) : ValidationErrors | null => {
        const pswRegexp = /^(?=.*\d+)(?=.*[a-zA-Z])[0-9a-zA-Z!@#$%^&*]{8,20}$/;
        var isInvalid = control.value && !pswRegexp.test(control.value);
        return isInvalid ? { invalidPassword: true } : null;
    }
}

export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: UntypedFormGroup) => {
        const password = group.controls[passwordKey];
        const passwordConfirmation = group.controls[passwordConfirmationKey];
        if (password.value !== passwordConfirmation.value) {
            return passwordConfirmation.setErrors({ mismatchedPasswords: true });
        }
    };
}

export function timeCheckValidator(startKey: string, endKey: string) {
    return (group: UntypedFormGroup) => {
        const start = group.controls[startKey];
        const end = group.controls[endKey];
        const startValue = start.value;
        const endValue = end.value;
        const startDate = new Date(`2020-01-01 ${startValue}`);
        let endDate = new Date(`2020-01-01 ${endValue}`);
        if (endDate.getHours() === 0 && endDate.getMinutes() === 0) {
            endDate = new Date(`2020-01-02 ${endValue}`);
        }
        if (startDate.getTime() > endDate.getTime()) {
            return start.setErrors({ startTimeGreaterThanEndTime: true });
        } else {
            return start.setErrors(null); // clear validatation error
        }
    };
}

export function identityValidator(idTypeKey: string, identityKey: string) {
    const type_id = '1';
    const type_passport = '2';
    const mishkal = '121212121';

    return (group: UntypedFormGroup) => {
        // type: (1)-ID (2)-Passport
        const typeControl = group.controls[idTypeKey];
        const idControl = group.controls[identityKey];
        const selectedType = typeControl.value;

        // console.log(JSON.stringify(idControl.errors));

        if (selectedType !== type_passport && selectedType !== type_id) {
            return idControl.setErrors(idControl.errors);
        }

        if (selectedType === type_passport && (idControl.value || '').trim() !== '') {
            return idControl.setErrors(idControl.errors); // clear validatation error
        } else if (selectedType === type_id) {
            if (idControl.value === '') {
                return idControl.setErrors(idControl.errors); // empty string is valid
            }

            const isValid = Utils.IsValidIsraeliID(idControl.value);

            // let isValid = sum % 10 == 0;
            // console.log(`${sum} % 10 = ${sum % 10}`);
            if (!isValid) {
                return idControl.setErrors({ invalidIsraelID: true });
            }
        }
    };
}

export function NotificationValidator(phoneKey: string, smsNotificationKey: string) {
    return (group: UntypedFormGroup) => {
        const phoneControl = group.controls[phoneKey];
        const checkboxControl = group.controls[smsNotificationKey];
        if (checkboxControl.value === true && (phoneControl.value || '').trim().length < 5) {
            return phoneControl.setErrors({ missingPhoneOrEmail: true });
        } else {
            if (phoneControl.errors && phoneControl.errors.required) {
                return phoneControl.setErrors(phoneControl.errors);
            } else {
                return phoneControl.setErrors(null);  // clear all
            }
        }
    };
}


export function PreferredNotificationValidator(checkboxSmsKey: string, checkboxEmailKey: string, checkboxDoNotNotifyKey: string) {
    return (group: UntypedFormGroup) => {        
        // when preferredNitifiaction is required at least one checkbox must be selected
        const checkboxSmsControl = group.controls[checkboxSmsKey];
        const checkboxEmailControl = group.controls[checkboxEmailKey];
        const checkboxDoNotNotifyControl = group.controls[checkboxDoNotNotifyKey];
        const preferredNotificationControl = group.controls["PreferredNotifications"];
        if(checkboxSmsControl.value === false && checkboxEmailControl.value === false && checkboxDoNotNotifyControl.value === false){
            return preferredNotificationControl.setErrors({ required: true });
        }
        return preferredNotificationControl.setErrors(null);
    };
}




